import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const menuMenuService = {
  getAllMenuPacks: (currentData, bypass = false) =>
    axiosService
      .get(`${urls.menu.menuDishes}?date=${currentData}${bypass ? '&bypass=true' : ''}`)
      .then((value) => value.data),
  getMenuPacksForClone: (date) =>
    axiosService
      .get(`${urls.menu.menuDishes}/clone-source?date=${date}`)
      .then((value) => value.data),
  createMenuPack: (data) =>
    axiosService
      .post(urls.menu.menuDishCreate, data)
      .then((value) => value.data),
  updateMenuPack: (id, data) =>
    axiosService
      .patch(`${urls.menu.menuDishCreate}/${id}`, data)
      .then((value) => value.data),
  deleteMenuDish: (menuId) =>
    axiosService
      .destroy(`${urls.menu.menuDishCreate}?menuId=${menuId}`)
      .then((value) => value.data),
  deleteByDate: (date) =>
    axiosService.destroy(`${urls.menu.menuDishCreate}/by-date/${date}`),
  cloneMenuToDate: (sourceDate, targetDate) =>
    axiosService
      .post(`${urls.menu.menuDishes}/clone`, {
        sourceDate: sourceDate,
        targetDate: targetDate,
        data: {
          sourceDate: sourceDate,
          targetDate: targetDate,
        },
      })
      .then((value) => value.data),

  syncForFutureDays: (date) =>
    axiosService
      .post(`${urls.menu.menuDishCreate}/fill-single-date`, {
        date,
      })
      .then((value) => value.data),
};

export { menuMenuService };
